import React from 'react'
import BodySection from '../../../components/AdminDashboard/SpaceBooking/EditSpace/BodySection'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const EditSpace = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>

            {/* sidenav */}
            <SideNav />

            {/* Body Section */}
            <BodySection />
            
        </div>
    )
}

export default EditSpace